import { negate } from 'lodash';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { filter, first, observeOn, switchMap } from 'rxjs/operators';
import { async } from 'rxjs/scheduler/async';
import { Subject } from 'rxjs/Subject';
var NotificationModel = /** @class */ (function () {
    function NotificationModel(visible) {
        if (visible === void 0) { visible = false; }
        this.visible = visible;
        this.showHide = new BehaviorSubject(false);
    }
    Object.defineProperty(NotificationModel.prototype, "mode", {
        get: function () {
            return this._mode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationModel.prototype, "message", {
        get: function () {
            return this._message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationModel.prototype, "modeText", {
        get: function () {
            return this._modeText;
        },
        enumerable: true,
        configurable: true
    });
    NotificationModel.prototype.onHide = function () {
        this.visible = false;
        this.showHide.next(false);
    };
    NotificationModel.prototype.show = function (mode, message, modeText) {
        this._mode = mode;
        this._message = message;
        this._modeText = modeText;
        this.visible = true;
        this.showHide.next(true);
        return this.showHide;
    };
    NotificationModel.prototype.loadAndShow = function (messageKey, mode, modeMessageKey, messageService, placeholders) {
        var _this = this;
        var messages$ = combineLatest([
            placeholders
                ? messageService.getMessageWithPlaceholder(messageKey, placeholders)
                : messageService.getMessage(messageKey),
            messageService.getMessage(modeMessageKey),
        ]);
        var notificationShownSubject = new Subject();
        messages$
            .pipe(switchMap(function (_a) {
            var msg = _a[0], modeMsg = _a[1];
            return _this.show(mode, msg, modeMsg);
        }), filter(negate(Boolean)), first())
            .subscribe(function () { return notificationShownSubject.next(true); }, function (err) {
            console.error(err);
            notificationShownSubject.next(false);
        });
        return notificationShownSubject.pipe(observeOn(async));
    };
    return NotificationModel;
}());
export { NotificationModel };
//# sourceMappingURL=notification.model.js.map